import React from 'react';

import { ThemeProvider } from 'react-jss';
import { getThemeByName } from 'themes/themeSelector';

const getComponentWithTheme = (component, themeName) => (
	<ThemeProvider theme={getThemeByName(themeName)}>
		{component}
	</ThemeProvider>
);

export default getComponentWithTheme;
